import { createIntl, createIntlCache } from 'react-intl';
import messagesObj from '../labels/messages_en.json';

const cache = createIntlCache();
const intl = createIntl({ locale: 'en', messages: messagesObj }, cache);

export const getI18nMessageFromGlobalStore = (labelKey, values, defaultMessage) => {
  const { messages = {}, formatMessage = () => {} } = intl;
  const message = messages[labelKey];
  return formatMessage(
    {
      id: labelKey,
      description: message || defaultMessage,
      defaultMessage: message || `+++ ${defaultMessage}`,
    },
    values,
  );
}

export default getI18nMessageFromGlobalStore;
